import PropTypes from 'prop-types';

const TimeInput24h = ({ value, onChange }) => {
  const handleChange = (e) => {
    const input = e.target.value;

    if (/^[0-9:]*$/.test(input)) {
      if (input.length <= 5) {
        let newValue = input;
        if (input.length === 2 && value.length === 1) {
          newValue = input + ':';
        }
        onChange(newValue);
      }
    }
  };

  const handleBlur = () => {
    const regex = /^([0-1]?[0-9]|2[0-3]):?([0-5][0-9])?$/;
    if (regex.test(value)) {
      const parts = value.split(':');
      const hours = parts[0] || '00';
      const minutes = parts[1] || '00';

      const formattedTime =
        `${hours.padStart(2, '0')}:${minutes.padEnd(2, '0')}`;
      onChange(formattedTime);
    } else {
      onChange(value && value.match(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/) ? value : '00:00');
    }
  };

  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="00:00"
      style={{
        padding: '8px 12px',
        border: '1px solid #ddd',
        borderRadius: '4px',
        fontSize: '16px',
        width: '80px',
        textAlign: 'center',
        fontFamily: 'monospace',
        letterSpacing: '1px',
      }}
    />
  );
};

TimeInput24h.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TimeInput24h;